import { render, staticRenderFns } from "./mobile-bottom-nav.vue?vue&type=template&id=076ef85e"
import script from "./mobile-bottom-nav.vue?vue&type=script&lang=js"
export * from "./mobile-bottom-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076ef85e')) {
      api.createRecord('076ef85e', component.options)
    } else {
      api.reload('076ef85e', component.options)
    }
    module.hot.accept("./mobile-bottom-nav.vue?vue&type=template&id=076ef85e", function () {
      api.rerender('076ef85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/mobile-bottom-nav.vue"
export default component.exports